<template>
  <b-col>
    <div
      class="row row-offer-content"
      @click.stop
      :class="{ stockItem: purchaseOffer._stock, efgItem: purchaseOffer._efg, bulk: purchaseOffer.creationType === 'bulk_upload'}"
    >
      <b-col cols="12" md="3" class="col-content">
        <b-row>
          <b-col cols="12" class="d-block d-sm-none">Merchant Email / Message</b-col>
          <b-col cols="12">
            <strong>{{ purchaseOffer.userEmail }}</strong> <br />
            {{ purchaseOffer.positionComment }}
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="2" class="col-content">
        <b-row>
          <b-col cols="5" class="d-block d-sm-none">Accessible by</b-col>
          <b-col cols="7" sm="12">
            <span v-if="purchaseOffer.watchesToAccessDate">
              {{ formattedDate(purchaseOffer.watchesToAccessDate) }}
            </span>
            <span class="text-in-stock" v-if="!purchaseOffer.watchesToAccessDate">
              <span class="badge badge-success">In stock</span>
            </span>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="2" class="col-content">
        <b-row>
          <b-col cols="5" class="d-block d-sm-none">Condition</b-col>
          <b-col cols="7" md="12">
            <strong v-if="purchaseOffer.price > 0">{{ purchaseOffer.price / 100 }} {{ purchaseOffer.currency }}</strong><br />
            <em v-if="purchaseOffer.tax !== ''">{{ purchaseOffer.tax }}</em>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="2" class="col-content">
        <b-row>
          <b-col cols="5" class="d-block d-sm-none">Offered</b-col>
          <b-col cols="7" md="12">
            <span :title="formattedTime(purchaseOffer.offeredAt)">{{ dateInWords(purchaseOffer.offeredAt) }} ago</span>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="2" class="col-content">
        <b-button-group>
          <b-button variant="primary" size="sm" @click="openAcceptForm()" :disabled="currentlySending">Accept</b-button>
          <b-button
            variant="warning"
            size="sm"
            @click="openRejectDialog()"
            :disabled="currentlySending || purchaseOffer.state !== PURCHASEOFFER.STATE.OPEN">
            Reject
          </b-button>
        </b-button-group>
      </b-col>

      <b-col cols="12" md="1" class="col-content">
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            :checked="purchaseOffer.state === PURCHASEOFFER.STATE.REQUESTED"
            type="checkbox"
            :id="'checkbox_' + _uid"
            @click="updateRequestStatus()"
            :disabled="purchaseOffer._status === OBJECTSTATE.BUSY"
          />

          <label class="form-check-label" :for="'checkbox_' + _uid">
            Request
          </label>
          <div v-if="purchaseOffer._status === OBJECTSTATE.BUSY">
            <b-spinner class="align-middle" small />
          </div>
          <div v-if="purchaseOffer._error">
            <b-icon-alert-triangle-fill
              aria-hidden="true"
              v-b-tooltip.hover
              :title="purchaseOffer._error.title + ' :\n ' + purchaseOffer._error.detail"
            />
          </div>
        </div>
      </b-col>
    </div>
    <purchase-offer-accept-form
      @cancel="closeAcceptForm()"
      @purchase-offer-accepted="$emit('purchase-offer-accepted')"
      v-if="showAcceptModal"
      :purchase-offer="purchaseOffer"
      :demand="demand"
    />
    <purchase-offer-reject-dialog
      :purchase-offer="purchaseOffer"
      @cancel="closeRejectDialog()"
      @purchase-offer-rejected="$emit('purchase-offer-rejected')"
      v-if="showRejectDialog"
    />
  </b-col>
</template>

<script>
import PurchaseOfferAcceptForm from './PurchaseOfferAcceptForm';
import PurchaseOfferRejectDialog from './PurchaseOfferRejectDialog';
import { timeFormatMixin } from 'Mixins/timeFormatMixin';
import { PURCHASEOFFERS } from 'src/store/actionTypes';
import { mapActions } from 'vuex';
import { getUser } from 'src/auth';
import PurchaseOffer from 'Constants/purchaseOffer';
import StoreObjects from 'src/constants/storeObjects';

export default {
  components: {
    PurchaseOfferAcceptForm,
    PurchaseOfferRejectDialog,
  },
  mixins: [timeFormatMixin],
  name: 'AdminPurchaseOfferRow',
  props: ['demand', 'purchaseOffer'],
  data() {
    return {
      showAcceptModal: false,
      showRejectDialog: false,
      currentlySending: false,
      submittedSuccessfully: false,
      PURCHASEOFFER: PurchaseOffer,
      OBJECTSTATE: StoreObjects.STATE,
      error: {
        blockPurchaseOffer: {
          isError: false,
          code: null,
          message: '',
        },
      },
    };
  },
  methods: {
    ...mapActions('purchaseOffers', {
      requestPurchaseOffer: PURCHASEOFFERS.BLOCK,
      unrequestPurchaseOffer: PURCHASEOFFERS.UNBLOCK,
    }),
    openAcceptForm() {
      this.showAcceptModal = true;
    },
    updateRequestStatus() {
      if (this.purchaseOffer.state === PurchaseOffer.STATE.OPEN) {
        this.requestPurchaseOffer({
          purchaseOfferId: this.purchaseOffer.purchaseOfferId,
          demandId: this.demand.demandId,
          userId: getUser().userId,
        });
      } else {
        this.unrequestPurchaseOffer({
          purchaseOfferId: this.purchaseOffer.purchaseOfferId,
          demandId: this.demand.demandId,
        });
      }
    },
    closeAcceptForm() {
      this.showAcceptModal = false;
    },
    resetError(errorKey) {
      this.error[errorKey].isError = false;
      this.error[errorKey].code = null;
      this.error[errorKey].message = '';
    },
    setError(errorKey, code, message) {
      this.error[errorKey].isError = true;
      this.error[errorKey].code = code;
      this.error[errorKey].message = message;
    },
    openRejectDialog() {
      this.showRejectDialog = true;
    },
    closeRejectDialog() {
      this.showRejectDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-xs {
  padding: 0.15rem 0.3rem;
  font-size: 0.85rem;
  line-height: 1.4;
  border-radius: 0.25rem;
}

.col-access-by-date {
  font-size: 0.9rem;
}

.col-content {
  padding-top: 4px;
  padding-bottom: 2px;
}

.text-in-stock {
  color: var(--success);
}

.row-offer-content {
  font-size: 0.95rem;
  margin-top: 3px;
  background-color: #eeeeee;
  border-left: 4px solid #bbb;
  &:hover,
  &:focus,
  &:active {
    background-color: #e3e3e3;
    border-left: 4px solid var(--primary);
  }

  @media all and(max-device-width: 576px) {
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  &.stockItem {
    background-color: darken(#eeeeee, 10%);
    border-left: 4px solid var(--success);

    &:hover,
    &:focus,
    &:active {
      background-color: darken(#e3e3e3, 10%);
      border-left: 4px solid var(--success);
    }
  }
  &.efgItem {
    background-color: darken(#00ffcc, 0%);

    &:hover,
    &:focus,
    &:active {
      background-color: darken(#00ffcc, 10%);
    }
  }
  &.bulk {
    background-color: darken(#fd7e14, 0%);

    &:hover,
    &:focus,
    &:active {
      background-color: darken(#fd7e14, 10%);
    }
  }
}
</style>
